import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.scss']
})
export class HomeFooterComponent implements OnInit {
  isIos=false
  constructor(public common : CommonService) { }

  ngOnInit(): void {
    if(Capacitor.getPlatform() === 'ios'){
      this.isIos=true
    }
  }

}
